
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selfserve",
      function () {
        return require("private-next-pages/selfserve/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selfserve"])
      });
    }
  